import { Centered, NullState } from '@mi-front/ui';
import WarningIcon from '@mui/icons-material/Warning';
import { FormattedMessage } from 'react-intl';

export function StationNotFoundPage() {
  return (
    <div className="position-relative vh-100">
      <Centered>
        <NullState className="text-center">
          <div>
            <WarningIcon sx={{ fontSize: 48 }} />
          </div>
          <h4 className="mt-3">
            <FormattedMessage
              id="common.stationNotFound.text"
              defaultMessage="Emisora no encontrada"
            />
          </h4>
        </NullState>
      </Centered>
    </div>
  );
}
